export default __webpack_public_path__ + "static/social-homicidios-mujeres-c9af5317e7b5f474289aebcb1d00008c.png";